import { render } from "./PublicLayout.vue?vue&type=template&id=beb910c0&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"

import "./PublicLayout.vue?vue&type=style&index=0&id=beb910c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb910c0"]])

export default __exports__